import type {ReactNode} from 'react'

interface FormSectionProps {
    title: string
    children: ReactNode
    'data-testid'?: string
}

export function FormSection({title, children, 'data-testid': testId}: FormSectionProps) {
    return (
        <div className="space-y-4" data-testid={testId}>
            <h4 className="font-medium">{title}</h4>
            {children}
        </div>
    )
}
